import { useIsFetching, useQueryClient } from "@tanstack/react-query";
import { RotateCcw } from "lucide-react";

// Release 1.5.0 header "Refresh" (O-R53): re-reads the open page's data from Summit Operations. GSS is not contacted; an
// Admin runs a GSS sync from Data sync. Spins while anything on the page is loading.

export function RefreshButton() {
  const queryClient = useQueryClient();
  const fetching = useIsFetching({ predicate: (q) => q.queryKey[0] !== "header" });
  return (
    <button
      type="button"
      className="btn-secondary hidden h-8 flex-none items-center gap-1.5 !px-2.5 md:inline-flex"
      onClick={() => void queryClient.invalidateQueries({ refetchType: "active" })}
      aria-busy={fetching > 0 || undefined}
      title="Re-read this page's data. GSS is not contacted."
      data-testid="header-refresh"
    >
      <RotateCcw aria-hidden="true" className={`h-3.5 w-3.5 ${fetching > 0 ? "animate-spin motion-reduce:animate-none" : ""}`} />
      <span className="hidden 2xl:inline">Refresh</span>
      <span className="sr-only 2xl:hidden">Refresh this page</span>
    </button>
  );
}
